<div class="sidenav" [@onSideNavChange]="
sideNavState
  ? 'open'
  : sideNavState !== false && sidenav.mode === 'over'
  ? 'collapse'
  : 'close'
">
    <div class="logo"></div>
    <mat-nav-list>
            <ng-container *ngFor="let route of menuLinks">
                <a mat-list-item *ngIf="!route.allowedRoles || (route.allowedRoles && route.allowedRoles.includes(user?.CurrentRoleInfo?.RoleName!))" 
                    [routerLink]="route.link" 
                    [queryParams]="route.params ? route.params : null" 
                    routerLinkActive="active" 
                    [matTooltipDisabled]="linkText" 
                    matTooltip="{{route.text}}" 
                    matTooltipPosition="right" 
                    matTooltipClass="navbar-tooltip">
                        <mat-icon>{{ route.icon }}</mat-icon>
                        <span [@animateText]="linkText ? 'show' : 'hide'" class="linkText">{{ route.text }}</span>
                </a>
            </ng-container>
            
            <a mat-list-item 
                (click)="logout()" 
                [matTooltipDisabled]="linkText" 
                matTooltip="LOGOUT" 
                matTooltipPosition="right" 
                matTooltipClass="navbar-tooltip">
                    <mat-icon>exit_to_app</mat-icon>
                    <span [@animateText]="linkText ? 'show' : 'hide'" class="linkText">LOGOUT</span>
            </a>

    </mat-nav-list>
    <div class="mini-collapse" *ngIf="!hideMiniButton" style="text-align: right;">
        <button mat-icon-button (click)="onSidenavToggle()">
            <mat-icon *ngIf="sideNavState">arrow_left</mat-icon>
            <mat-icon *ngIf="!sideNavState">arrow_right</mat-icon>
        </button>
    </div>
    <span [@animateText]="linkText ? 'show' : 'hide'" class="linkText helpTip" *ngIf="!hideMiniButton">
        <em>Need more space? Click the <mat-icon>arrow_left</mat-icon> button to change this menu to a menu toolstrip.</em>
    </span>
</div>